<template>
  <div class="product">
    <!-- nav -->
    <Navbar style="height: 7.3rem" id="top" />
    <!-- banner -->
    <section class="banner">
      <img src="@/assets/images/contactbanner.png" alt="" />
    </section>
    <!-- content -->
    <div class="content">
      <div class="con_text">
        <h1>联系我们</h1>
        <div>
          <p style="line-height: 1rem">
            <img src="@/assets/images/icon_phone.png" alt="" />
            售后服务热线: 400-869-0707
          </p>
          <p>
            <img src="@/assets/images/companyicon.png" alt="" />
            公司信息：上海艾荣达健身科技有限公司
          </p>
        </div>
        <ul class="cir">
          <li>
            <a
              class="slide"
              target="_blank"
              href="https://www.douyin.com/user/MS4wLjABAAAA55glC_Kh8uYPiDzSF3wOjscq03IsM_pYeuMDd0xGpxkHtuiSYjL91jeCCBsAd-SC"
            >
              <img src="@/assets/images/icon_tiktok_black.png" alt="" />
            </a>
          </li>
          <li>
            <a
              class="slide"
              target="_blank"
              href="https://www.xiaohongshu.com/user/profile/5bddb5dd852a0c0001cc29eb?xhsshare=CopyLink&appuid=5bddb5dd852a0c0001cc29eb&apptime=1667356352"
            >
              <img src="@/assets/images/ic_red_black.png" alt="" />
            </a>
          </li>
          <li>
            <a
              class="slide"
              href="https://weibo.com/u/5933324230"
              target="_blank"
            >
              <img src="@/assets/images/ic_weibo_black.png" alt="" />
            </a>
          </li>
          <li class="Weshow">
            <div class="slide">
              <img src="@/assets/images/ic_wechat_black.png" alt="" />
            </div>
            <div class="box none">
              <!-- <div class="box_angle"></div> -->
              <img src="@/assets/images/weChat_momoda.jpg" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="con_info"> -->
      <div class="con_info">
        <h2>门店查找</h2>
      </div>
      <!-- 地图 -->
      <div class="mapbox">
        <!-- 搜索容器 -->
        <div class="mapsearch" id="rResult">
          <div class="SEarch">
            <el-input placeholder="请输入您想搜索的城市名" v-model="Search">
            </el-input>
            <i
              class="el-icon-circle-close close"
              v-if="Search"
              @click="Search = ''"
            ></i>
            <i class="el-icon-search searchIcon" @click="searchPlaces()"></i>
          </div>
          <!-- 数据容器 -->
          <div class="mapresult">
            <ul>
              <li
                :class="listAct === index ? 'on' : ''"
                v-for="(item, index) in results"
                :key="index"
                @click="selectPlace(item, index)"
              >
                <div class="num">{{ index + 1 }}</div>
                <div>
                  <p>
                    {{ item.store_name }}
                  </p>
                  <p>
                    <img src="@/assets/images/icon_locate.png" alt="" />
                    {{ item.address }}
                  </p>
                  <p>
                    <img src="@/assets/images/icon_phone.png" alt="" />
                    {{ item.phone }}
                  </p>
                </div>
              </li>
              <p class="none" v-if="results.length == 0">
                搜索结果暂无门店信息
              </p>
            </ul>
          </div>
        </div>
        <!-- 地图渲染 -->
        <div class="mapshow">
          <div id="map" style="width: 100%; height: 836px"></div>
        </div>
      </div>
      <div class="con_info">
        <h2>线下共享体验</h2>
        <img src="@/assets/images/scene.png" alt="" />
        <img src="@/assets/images/scene2.png" alt="" />
        <!-- <img src="@/assets/images/ditu.png" alt="" /> -->
      </div>
    </div>

    <!-- foot -->
    <Foot />
  </div>
</template>
<script>
import { store_list } from "@/request/http";
import Navbar from "@/components/nav.vue";
import Foot from "@/components/foot.vue";
export default {
  name: "contact",
  components: {
    Navbar,
    Foot,
  },
  data() {
    return {
      listAct: null,
      Search: "", //搜索
      local: "",
      BMap: "",
      map: null,
      places: [],
      selectedPlace: null,
      showInfoWindow: false,
      infoWindowStyle: {
        position: "absolute",
        zIndex: 1000,
      },
      results: [],
    };
  },
  mounted() {
    document.getElementById("top").scrollIntoView({ behavior: "smooth" });
    const checkBMap = setInterval(() => {
      if (window.BMap) {
        clearInterval(checkBMap);
        this.initMap();
      }
    }, 100);
  },
  methods: {
    // --------
    initMap() {
      this.map = new BMap.Map("map", { enableMapClick: false });
      this.map.disableDragging();
      // const point = new BMap.Point("上海");

      this.map.centerAndZoom("上海", 12);
      // this.map.centerAndZoom(this.Search, 12);
      store_list().then((res) => {
        console.log(res);
        this.results = res.data.data;
        this.map.clearOverlays();
        this.results.forEach((item) => {
          this.addMarker(item); // 为每个搜索结果添加标注
        });
      });
    },
    searchPlaces() {
      store_list({ search: this.Search }).then((res) => {
        this.results = res.data.data;
        if (this.Search == "") {
          this.map.centerAndZoom("上海", 12);
        }
        if (this.results.length == 0 && this.Search !== "") {
          this.map.centerAndZoom(this.Search, 12);
        }
      });
    },
    addMarker(place) {
      var point = new BMap.Point(place.longitude, place.latitude);
      var dialog =
        '<div class="info-window"><h3>' +
        place.store_name +
        "</h3><p><span>地址：</span><span>" +
        place.address +
        "</span></p><button id='endAddress' >到这去<span class='locat'></span></button>";
      var dia = new BMap.InfoWindow(dialog);
      const marker = new BMap.Marker(point);
      this.map.addOverlay(marker);
      this.map.panTo(point);
      marker.addEventListener("click", () => {
        this.selectedPlace = {
          title: place.title,
          address: place.address,
          point: point,
        };
        this.map.openInfoWindow(dia, point);
        const element = document.getElementById("endAddress");
        element.addEventListener("click", () => {
          const url = `http://api.map.baidu.com/marker?location=${place.latitude},${place.longitude}&title=${place.store_name}&content=${place.address}&output=html`;
          window.open(url, "_blank"); // 在新窗口打开百度地图
        });
      });
    },
    selectPlace(place, i) {
      var point = new BMap.Point(place.longitude, place.latitude);
      var dialog =
        '<div class="info-window"><h3>' +
        place.store_name +
        "</h3><p><span>地址：</span><span>" +
        place.address +
        "</span></p><button id='endAddress' >到这去<span class='locat'></span></button>";
      var dia = new BMap.InfoWindow(dialog);
      this.map.openInfoWindow(dia, point);
      this.map.panTo(point);
      this.listAct = i;
      this.selectedPlace = {
        title: place.title,
        address: place.address,
        point: point,
      };
      const element = document.getElementById("endAddress");
      element.addEventListener("click", () => {
        const url = `http://api.map.baidu.com/marker?location=${place.latitude},${place.longitude}&title=${place.store_name}&content=${place.address}&output=html`;
        window.open(url, "_blank"); // 在新窗口打开百度地图
      });
    },
  },
};
</script>
<style type="text/css">
.BMap_cpyCtrl {
  display: none;
}
.anchorBL {
  display: none;
}
.info-window {
  display: flex;
  flex-direction: column;
  width: 384px;
  position: absolute;
  z-index: 1000;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 3px 12px #a3a8b721;
  padding: 20px;
}
.BMap_center {
  width: 384px;
}
.info-window h3 {
  font-size: 20px;
  line-height: 28px;
  color: #333;
}
.info-window p {
  font-size: 17px;
  line-height: 24px;
  color: #666;
  margin: 8px 0 16px;
  display: flex;
}
.info-window p span:first-child {
  white-space: nowrap;
}
.info-window p span {
  display: block;
}
.info-window button {
  width: 157px;
  height: 44px;
  mix-blend-mode: normal;
  border-radius: 12px;
  background: #222222;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  line-height: 24px;
  box-sizing: border-box;
  cursor: pointer;
  padding-left: 20px;
}
.info-window p img {
  width: 26px;
  height: 26px;
  margin-left: 4px;
}
.info-window p img.black {
  display: none;
}
.info-window button:hover {
  border: 2px solid #222222;
  background: #ffffff;
  color: #222222;
}
.info-window p img.white {
  display: none;
}
.info-window p img.black {
  display: block;
}
.locat {
  background: url("../assets/images/icon_locate2.png") no-repeat 100%;
  display: block;
  height: 30px;
  width: 30px;
}
.info-window button:hover .locat {
  background: url("../assets/images/icon_locate.png") no-repeat 100%;
}
/*地图标题 infoWindow*/
.BMap_bubble_title {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  background: transparent !important;
}

.BMap_pop .BMap_top {
  background: rgba(0, 0, 0, 0) !important;
  border: 0 !important;
}

.BMap_pop .BMap_center {
  width: 281px !important;
  border: 0 !important;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop .BMap_bottom {
  border: 0 !important;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop div:nth-child(3) {
  background: transparent !important;
}

.BMap_pop div:nth-child(3) div {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0) !important;
  border: 0 !important;
}

.BMap_pop div:nth-child(1) {
  /* border-radius: 3px 0 0 0;
  background: transparent !important; */
  border: 0 !important;
}
.BMap_pop div:nth-child(8) {
  display: none !important;
}
.BMap_pop div:nth-child(9) {
  overflow: visible !important;
}
.BMap_pop div:nth-child(1) div {
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop div:nth-child(5) {
  border-radius: 0 0 0 3px;
  background: transparent !important;
  border: 0 !important;
}

.BMap_pop div:nth-child(5) div {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop div:nth-child(7) {
  background: transparent !important;
  left: 226px;
}

.BMap_pop div:nth-child(7) div {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0) !important;
}

.BMap_pop img {
  display: none;
}
.BMap_shadow {
  display: none !important;
}
</style>
<style lang="scss" scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.content {
  width: 80%;
  margin: 0 auto;
  .con_text {
    width: 35%;
    margin: 2rem auto;
    text-align: center;
    line-height: 7rem;
    > div {
      text-align: left;
      align-items: center;
      margin-left: 4.5rem;
      p {
        display: flex;
        align-items: center;
        img {
          width: 26px;
          height: 26px;
          margin-right: 10px;
        }
      }
    }
    .cir {
      margin-top: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      li {
        position: relative;
        .slide {
          width: 5rem;
          height: 5rem;
          line-height: 5rem;
          padding: 1rem;
          border: 1px solid #e3e3e3;
          border-radius: 100%;
          cursor: pointer;
          display: block;
          > img {
            width: 100%;
            border-radius: 100%;
          }
        }
        .none {
          display: none;
        }
        .box {
          position: absolute;
          right: -13rem;
          top: -3.5rem;
          width: 12rem;
          height: 12rem;
          padding: 0.2rem;
          background: #101010;
          img {
            width: 100%;
          }
        }
        .box_r {
          left: -13rem;
        }
        .box_angle {
          width: 0;
          position: absolute;
          top: 5rem;
          left: -1.5rem;
          height: 0;
          border-right: 1.5rem solid #fff;
          border-bottom: 1.5rem solid transparent;
          border-top: 1.5rem solid transparent;
        }
        .box_angle_r {
          position: absolute;
          top: 5rem;
          right: -1.5rem;
          width: 0;
          height: 0;
          border-top: 1.5rem solid transparent;
          border-left: 1.5rem solid #fff;
          border-bottom: 1.5rem solid transparent;
        }
      }
    }
  }
  .con_info {
    h2 {
      margin: 2rem 0;
      color: #101010;
    }
    > img {
      width: 100%;
    }
    .location {
      display: flex;
      justify-content: center;
      gap: 5rem;
      align-items: center;
      margin-top: 1rem;
      section {
        text-align: center;
        line-height: 3rem;
        img {
          width: 2rem;
          height: 2rem;
        }
      }
    }
  }
}
.Weshow:hover .box {
  display: block !important;
}
#container {
  overflow: hidden;
  width: 100%;
  height: 836px;
  // margin: 0 auto;
  font-family: "微软雅黑";
}
.mapbox {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  // align-items: center;
  // width: 80%;
  margin: 0 auto;
  position: relative;
  .mapsearch {
    width: 614px;
    height: 836px;
    min-width: 30%;
    margin-right: 20px;
    border-radius: 20px;
    background: #f6f6f6;
    overflow: hidden;
    .SEarch {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      margin: 40px 24px;
      /deep/.el-input {
        border-radius: 16px;
        padding-right: 100px;
        background: #fff;
      }
      /deep/.el-input__inner {
        height: 68px;
        font-size: 20px;
        border: 0;
        border-radius: 16px;
        padding-right: 10px;
      }
      .searchIcon {
        position: absolute;
        right: 1px;
        font-size: 28px;
        font-weight: bold;
        color: #666;
        cursor: pointer;
        display: block;
        padding: 19px;
        top: 1px;
        background: #fff;
        border-radius: 16px;
      }
      .close {
        position: absolute;
        right: 66px;
        background: #fff;
        cursor: pointer;
        font-weight: bold;
        color: #999;
        font-size: 24px;
      }
    }
    .mapresult {
      margin-top: 32px;
      height: 81%;
      overflow-y: scroll;
      .none {
        padding-left: 24px;
        color: #b6bbc2;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        margin-top: 40%;
      }
      ul li {
        cursor: pointer;
        padding: 24px;
        display: flex;
        //justify-content: space-between;
        color: #333;
        font-size: 20px;
        line-height: 28px;
        .num {
          margin-right: 24px;
        }
        p {
          display: flex;
          //align-items: center;
          img {
            width: 26px;
            height: 26px;
            margin-right: 6px;
          }
        }
        p:nth-child(2) {
          margin: 16px 0;
        }
      }
      ul li:hover {
        background: #eeeff0;
      }
      ul li.on {
        background: #eeeff0;
      }
      // height: 400px;
      // overflow: auto;
    }
  }
  .mapshow {
    width: 100%;
    position: relative;
  }

  .info-window {
    display: flex;
    flex-direction: column;
    width: 384px;
    position: absolute;
    z-index: 1000;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0px 3px 12px #a3a8b721;
    padding: 20px;
    h3 {
      font-size: 20px;
      line-height: 28px;
      color: #333;
    }
    p {
      font-size: 17px;
      line-height: 24px;
      color: #666;
      margin: 8px 0 16px;
      display: flex;
      span:first-child {
        white-space: nowrap;
      }
      span {
        display: block;
      }
    }
    button {
      width: 157px;
      height: 44px;
      mix-blend-mode: normal;
      border-radius: 12px;
      background: #222222;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      line-height: 24px;
      box-sizing: border-box;
      cursor: pointer;
      padding-left: 20px;
      img {
        width: 26px;
        height: 26px;
        margin-left: 4px;
      }
      img.black {
        display: none;
      }
    }
    .locat {
      background: url("../assets/images/icon_locate.png") no-repeat;
    }
    button:hover {
      border: 2px solid #222222;
      background: #ffffff;
      color: #222222;
      .locate {
      }
      img.white {
        display: none;
      }
      img.black {
        display: block;
      }
    }
  }
}
</style>
